import React from 'react';
import ReactDOM from 'react-dom';

import {Provider} from 'react-redux';
import {createBrowserHistory} from 'history';
import {Router} from 'react-router-dom';
import {createReduxHistoryContext} from 'redux-first-history';
import {injectReducer} from 'redux-injector';
import {dynamicMiddlewaresInstance, store} from '@dized/ui/dist/redux/store';

import {ThemeProvider} from 'styled-components';
import theme from './common/styles/Theme';

import './index.css';
// NOTE: this must be imported after the Redux store has been initialized
import Portal from './views/Portal';

import apiMiddleware from './middleware/apiMiddleware';
import createRootReducer from './reducers';

const history = createBrowserHistory();

const {routerMiddleware, createReduxHistory} = createReduxHistoryContext({
  history,
  store,
  createRootReducer,
});

// inject application middlewares
dynamicMiddlewaresInstance.addMiddleware(routerMiddleware);
dynamicMiddlewaresInstance.addMiddleware(apiMiddleware);

// inject application reducers
Object.entries(createRootReducer(history)).forEach(([key, reducer]) =>
  injectReducer(key, reducer),
);

const reduxHistory = createReduxHistory(store);

ReactDOM.render(
  <Provider store={store}>
    <ThemeProvider theme={theme}>
      <Router history={reduxHistory}>
        <Portal history={reduxHistory} />
      </Router>
    </ThemeProvider>
  </Provider>,
  document.getElementById('root'),
);
